import { render } from "./MultipleVisitAxxesscare.vue?vue&type=template&id=4da05d43&ts=true"
import script from "./MultipleVisitAxxesscare.ts?vue&type=script&lang=ts&external"
export * from "./MultipleVisitAxxesscare.ts?vue&type=script&lang=ts&external"

import "./MultipleVisitAxxesscare.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__